import { useNotify } from 'react-admin';
import { NOTIFY_DEFAULT_MESSAGE } from './constants';
import { UseCopyToClipboardProps } from './types';

const useCopyToClipboard = () => {
  const notify = useNotify();

  const copyToClipboard = async ({ notifyProps, onCopied, textToCopy }: UseCopyToClipboardProps) => {
    const { onError, onSuccess } = notifyProps || {};

    try {
      await navigator.clipboard?.writeText?.(textToCopy);
      const { message, options } = onSuccess || {};

      notify(message ?? NOTIFY_DEFAULT_MESSAGE.success, { ...options, type: options?.type ?? 'info' });
      onCopied?.();
    } catch {
      const { message, options } = onError || {};
      notify(message ?? NOTIFY_DEFAULT_MESSAGE.error, { ...options, type: options?.type ?? 'warning' });
    }
  };

  return {
    copyToClipboard,
  };
};

export default useCopyToClipboard;
